import axios from "axios";
// const serverURL = "http://localhost:14000";
const serverURL = "https://api.delhibookstore.com";

const postData = async (url, body) => {
  try {
    // console.log(JSON.stringify(body));
    var response = await axios.post(`${serverURL}/${url}`, body, {
      withCredentials: true
    });


    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

const getData = async (url) => {
  try {
    var response = await axios.get(`${serverURL}/${url}`, { withCredentials: true });
    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

const axiosInstance = axios.create({
  baseURL: serverURL,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true,
  timeout: 1200000
})

export default axiosInstance
export { serverURL, postData, getData };
